export default __webpack_public_path__ + "static/media/104.690a9991.jpg";